import { useEffect, useState } from 'react';
import { useSessionStorage } from 'react-use';
import { getUserAttributes } from '@noths/polaris-client-user-configuration';

export const MEMBERSHIP_EXPIRY_DATE_STORAGE_KEY = 'CLIENT_SITE_CHROME__MEMBERSHIP_EXPIRY_DATE';
export const MEMBERSHIP_IS_ACTIVE_STORAGE_KEY = 'CLIENT_SITE_CHROME__MEMBERSHIP_IS_ACTIVE';

export const useMembership = () => {
  const [membershipExpiryDate, setMembershipExpiryDate] = useState<string | null>(null);
  const [membershipIsActive, setMembershipIsActive] = useState<boolean>(false);
  const [cachedUserMembershipExpiry, setCachedMembershipExpiryDate] = useSessionStorage<
    string | null
  >(MEMBERSHIP_EXPIRY_DATE_STORAGE_KEY, membershipExpiryDate);
  const [cachedMembershipIsActive, setCachedMembershipIsActive] = useSessionStorage<boolean>(
    MEMBERSHIP_IS_ACTIVE_STORAGE_KEY,
    membershipIsActive,
  );

  useEffect(() => {
    setMembershipExpiryDate(cachedUserMembershipExpiry);
    setMembershipIsActive(cachedMembershipIsActive);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let cancelled = false;
    async function getMembership() {
      const newValueContainer = await getUserAttributes();

      const newMembershipExpiryDateValue = newValueContainer
        ? newValueContainer.membershipExpiryDate
        : null;
      const newMembershipIsActiveValue = newValueContainer
        ? newValueContainer.membershipIsActive
        : false;
      if (!cancelled) {
        setMembershipExpiryDate(newMembershipExpiryDateValue);
        setCachedMembershipExpiryDate(newMembershipExpiryDateValue);
        setMembershipIsActive(newMembershipIsActiveValue);
        setCachedMembershipIsActive(newMembershipIsActiveValue);
      }
    }

    getMembership();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    membershipExpiryDate,
    membershipIsActive,
  };
};
